
import ErpBookingsList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/bookings") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpBookingsList();
    }
}